export const ROLE = '/role/'
export const ROLE_ALL = `${ROLE}all`
